import React from "react";
import { useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";

/* img imports */
import carrotRunnerThumb from "../assets/games/carrot-runner.png";
import picnicFoodBuilderThumb from "../assets/games/picnic-food-builder.png";
import healthyFoodTowerThumb from "../assets/games/healthy-food-tower.png";

/* js imports */
import useCheckPathName from "../utils/useCheckPathname";
// import { dogMoveAnime } from "../assets/js/animations";

/* comp imports */
import BackArrow from "../components/BackArrow";
import PageTransition from "../components/PageTransition";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

const Games = () => {
  useCheckPathName();
  const navigate = useNavigate();
  const handleRedirect = (pageName) => {
    navigate(pageName);
  };
  return (
    <>
      <PageTransition />
      <div className="page-main-wrapper games-page-main-wrapper">
        <BackArrow handleRedirect={handleRedirect} linkName="/inner-tents" />
        <div
          className="games-thumb carrot-runner-thumb"
          onClick={() => {
            handleRedirect("/carrot-runner");
          }}
        >
          <img src={carrotRunnerThumb} alt="Carrot Runner Thumbnail" />
          <div className="game-enter-btn">PLAY</div>
        </div>
        {/* end of game thumb 1 */}
        <div
          className="games-thumb picnic-food-builder-thumb"
          onClick={() => {
            handleRedirect("/picnic-food-builder");
          }}
        >
          <img
            src={picnicFoodBuilderThumb}
            alt="Picnic Food Builder Thumbnail"
          />
          <div className="game-enter-btn">PLAY</div>
        </div>
        {/* end of game thumb 2 */}
        <div
          className="games-thumb healthy-food-tower-thumb"
          onClick={() => {
            handleRedirect("/healthy-food-tower");
          }}
        >
          <img src={healthyFoodTowerThumb} alt="Healthy Food Tower Thumbnail" />
          <div className="game-enter-btn">PLAY</div>
        </div>
        {/* end of game thumb 3 */}
        {/* <motion.div
          className="dog-wrapper"
          variants={dogMoveAnime}
          initial="initial"
          animate="animate"
        ></motion.div> */}
        <MainDisclaimerModal />
      </div>
    </>
  );
};

export default Games;
